import { MAX_FIELD_PAGE_SIZE } from '@cibo/core'
import { usePaginatedFields } from '@cibo/landmanager'
import { useProgramConfigs } from '@cibo/programs'
import { useMemo } from 'react'

export const useUnprofiledFields = (query?: any, options?: any) => {
  const programs = useProgramConfigs()

  const programIds = programs.data?.map(({ programId }) => programId)

  const unprofiledQuery = useMemo(
    () => ({
      anyPrograms: programIds?.map(programId => ({
        id: programId,
        benchmarks: [{ benchmark: 'profile', status: 'incomplete' }],
      })),
      footprintResolved: true,
      ...query,
    }),
    [programIds?.join(',')]
  )

  return usePaginatedFields(0, MAX_FIELD_PAGE_SIZE, unprofiledQuery, {
    enabled: !!programIds,
    ...options,
  })
}

export const useNeedsInfoFieldsCount = (query?: any, options?: any) => {
  const programs = useProgramConfigs()

  const programIds = programs.data?.map(({ programId }) => programId)

  const unprofiledQuery = useMemo(
    () => ({
      anyPrograms: programIds?.map(programId => ({
        id: programId,
        benchmarks: [{ benchmark: 'profile', status: 'incomplete' }],
      })),
      footprintResolved: true,
      ...query,
    }),
    [programIds?.join(',')]
  )

  return usePaginatedFields(0, 1, unprofiledQuery, {
    enabled: !!programIds,
    ...options,
  })
}
